import React from 'react';
import {
  CModal,
  CModalHeader,
  CModalTitle,
  CModalBody,
  CModalFooter,
  CButton,
} from '@coreui/react';
import { GetChart } from 'components/Dashboard/GetChart';
export const PreviewModal = ({ visible, setVisible, previewData }) => {
  const { updatedAt, data: dashboardData } = previewData;

  function getDeviceData(arr) {
    if (!arr) return [];
    const result = [];
    let currentDevice = null;

    for (let i = 1; i < arr.length; i++) {
      const [deviceId, criteria, value] = arr[i];

      if (deviceId) {
        currentDevice = {
          deviceId,
          data: [],
        };
        result.push(currentDevice);
      }

      if (currentDevice) {
        currentDevice.data.push({
          criteria,
          value,
        });
      }
    }

    return result;
  }

  function removeDeviceIdColumn(data) {
    if (!data) return [];
    const copiedData = data.map((row) => [...row]);
    return copiedData.map((row) => row.slice(1));
  }

  const data = getDeviceData(dashboardData);
  const dataRemoveDeviceId = removeDeviceIdColumn(dashboardData);

  function formatDate(date) {
    const d = new Date(date);
    const day = String(d.getDate()).padStart(2, '0');
    const month = String(d.getMonth() + 1).padStart(2, '0'); // Tháng bắt đầu từ 0
    const year = d.getFullYear();
    const hours = String(d.getHours()).padStart(2, '0');
    const minutes = String(d.getMinutes()).padStart(2, '0');
    const seconds = String(d.getSeconds()).padStart(2, '0');

    return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
  }

  const formattedDate = formatDate(new Date());
  console.log(formattedDate); // Output: 20/12/2024 14:30:45

  const finalId = data[0]?.deviceId;

  return (
    <CModal
      visible={visible}
      onClose={() => setVisible(false)}
      className="preview-modal"
      size="lg"
    >
      <CModalHeader>
        <CModalTitle>Preview Data</CModalTitle>
      </CModalHeader>
      <CModalBody style={{ fontSize: '14px', overflowX: 'auto' }}>
        <div className="table-header">
          <p>ID: {data[0]?.deviceId}</p>
          <p>Hardware: {data[0]?.deviceId.toUpperCase()}</p>
        </div>
        <table className="table table-bordered">
          <thead>
            <tr>
              {dataRemoveDeviceId[0]?.map((item, index) => (
                <th key={index}>{item}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {dataRemoveDeviceId.map((item, index) => {
              if (index === 0) return null;
              return (
                <tr key={index}>
                  {item.map((item, index) => (
                    <td key={index}>{item}</td>
                  ))}
                </tr>
              );
            })}
          </tbody>
        </table>
        <div className="chart-container">
          <GetChart finalId={finalId} dashboard={dashboardData} />
        </div>
      </CModalBody>
      <CModalFooter>
        <p className="last-update">Last update: {formatDate(updatedAt)}</p>
        <CButton color="secondary" onClick={() => setVisible(false)}>
          Close
        </CButton>
      </CModalFooter>
    </CModal>
  );
};
